import { gql } from "@apollo/client";

export const PAYMENT_TERMINAL_FRAGMENT = gql`
  fragment PaymentTerminal on PaymentTerminal {
    id
    name
    stripeTerminalId
    serialNumber
    venueId
    createdAt
    updatedAt
  }
`;
